import { parseQuery } from '@shoppykey/tools';
import dayjs from 'dayjs';
import { map, toNumber, toPairs } from 'lodash';

export const getPageQuery = () => {
  const { href } = window.location;
  const qsIndex = href.indexOf('?');
  const sharpIndex = href.indexOf('#');

  if (qsIndex !== -1) {
    if (qsIndex > sharpIndex) {
      return parseQuery(href.split('?')[1]);
    }

    return parseQuery(href.slice(qsIndex + 1, sharpIndex));
  }

  return {};
};

export function reloadPage(): void {
  window.location.reload();
}

export const replaceGoto = () => {
  const urlParams = new URL(window.location.href);
  const params = getPageQuery();
  let { redirect } = params as { redirect: string };
  if (redirect) {
    const redirectUrlParams = new URL(redirect);
    if (redirectUrlParams.origin === urlParams.origin) {
      redirect = redirect.substr(urlParams.origin.length);
      if (redirect.match(/^\/.*#/)) {
        redirect = redirect.substr(redirect.indexOf('#'));
      }
    } else {
      window.history.replaceState({}, 'title', '/');
      reloadPage();
      return;
    }
  }
  const url = urlParams.href.split(urlParams.pathname)[0] + (redirect || '/');
  window.history.replaceState({}, 'title', url);
  reloadPage();
};

export function formulaToNumber(formula?: string): number {
  const num = toNumber(formula);
  if (isNaN(num)) {
    return 0;
  }
  return num;
}

// 数组转formValue
export const convertArrayToFormValue = (array: any[]) => {
  return array.reduce((pre, cur) => {
    return {
      ...pre,
      [cur.id]: { ...cur },
    };
  }, {});
};

// formValue转数组
export const convertFormValueToArray = (formValue: Record<string, any>) => {
  return map(toPairs(formValue), ([id, item]) => ({
    id,
    ...item,
  }));
};

export function formatQueryArray(value?: any) {
  if (!value) return undefined;
  return Array.isArray(value) ? value : [value];
}

export function currentYearRange() {
  return [dayjs().startOf('year').valueOf(), dayjs().endOf('year').valueOf()];
}

export function formattedNumber(value: string | number) {
  let _value = value;
  if (typeof value === 'string') {
    _value = parseFloat(value);
  }

  if (isNaN(_value as number)) {
    return _value;
  }

  return _value ? _value.toLocaleString() : _value;
}
